module.exports = __webpack_public_path__ + "img/simplepay_otp_hu_top_cropped.d3a50896.png";